<template>
  <div v-if="orderDelivery.length > 0">
    <div v-for="delivery in orderDelivery" :key="delivery.deliveryType">
      <div class="flex flex-item1 mar20-b border" v-if="delivery.deliveryType == 'SHSM'">
        <div class="min-w373">
          <div class="flex pad25">
            <div class="wh100 radius4 overflow">
              <img :src="goodsPic + '?imageView2/1/w/100/h/100'" />
            </div>
            <div class="mar15-l lh28">
              <div class="flex">
                <div class="no-warp gray6">发货方式</div>
                <div class="mar10-l">送货上门</div>
              </div>
              <div class="flex">
                <div class="no-warp gray6">车主姓名</div>
                <div class="mar10-l" v-if="dataMasking">
                  {{ delivery.logisticsCompanyName.substring(0, 1) + new Array(delivery.logisticsCompanyName.length).join("*") }}
                </div>
                <div class="mar10-l" v-else>{{ delivery.logisticsCompanyName }}</div>
              </div>
              <div class="flex">
                <div class="no-warp gray6">车主电话</div>
                <div class="mar10-l" v-if="dataMasking">{{ delivery.logisticInfo.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2") }}</div>
                <div class="mar10-l" v-else>{{ delivery.logisticInfo }}</div>
              </div>
              <div class="flex">
                <div class="no-warp gray6" style="width: 58px">车牌号</div>
                <div class="mar10-l" v-if="dataMasking">{{ delivery.licensePlate.replace(/^(.{1}).+(.)/, "$1**$2") }}</div>
                <div class="mar10-l" v-else>{{ delivery.licensePlate }}</div>
              </div>
              <div class="flex">
                <div class="no-warp gray6" style="width: 58px">发货时间</div>
                <div class="mar10-l">{{ delivery.sendTime }}</div>
              </div>
              <div class="flex" v-if="delivery.goodsQuantity && delivery.goodsQuantity > 1">
                <div class="no-warp gray6" style="width: 58px">发货数量</div>
                <div class="mar10-l">{{ delivery.goodsQuantity }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="border-l flex-auto pad30">
          <div class="flex mar20-b items-center">
            <img src="../../order/detail/images/cart.png" />
            <div class="mar10-l fb f16">物流跟踪</div>
          </div>
          <div class="text-center relative mar-t-20">
            <img src="../../order/detail/images/cart-trans.png" />
          </div>
          <div class="text-center mar10-t">暂无物流相关信息，如有疑问，请联系平台客服</div>
        </div>
      </div>
      <div class="flex flex-item1 mar20-b border" v-if="delivery.deliveryType == 'LOGISTICS'">
        <div class="flex flex-column min-w373">
          <div class="flex pad25">
            <div class="wh100 radius4 overflow">
              <img :src="goodsPic + '?imageView2/1/w/100/h/100'" />
            </div>
            <div class="mar15-l lh28">
              <div class="flex">
                <div class="no-warp gray6">发货方式</div>
                <div class="mar10-l">物流发货</div>
              </div>
              <div class="flex">
                <div class="no-warp gray6">物流名称</div>
                <div class="mar10-l" v-if="dataMasking">{{ delivery.logisticsCompanyName.replace(/^(.{1}).+(.)/, "$1**$2") }}</div>
                <div class="mar10-l" v-else>{{ delivery.logisticsCompanyName }}</div>
              </div>
              <div class="flex">
                <div class="no-warp gray6">物流单号</div>
                <div class="mar10-l" v-if="dataMasking">{{ delivery.logisticsNum.replace(/^(.{1}).+(.)/, "$1**$2") }}</div>
                <div class="mar10-l" v-else>{{ delivery.logisticsNum }}</div>
              </div>
              <div class="flex">
                <div class="no-warp gray6" style="width: 58px">发货时间</div>
                <div class="mar10-l">{{ delivery.sendTime }}</div>
              </div>
              <div class="flex" v-if="delivery && delivery.goodsQuantity > 1">
                <div class="no-warp gray6" style="width: 58px">发货数量</div>
                <div class="mar10-l">{{ delivery.goodsQuantity }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="border-l flex-auto pad30">
          <div class="flex mar20-b items-center">
            <img src="../../order/detail/images/cart.png" />
            <div class="mar10-l fb f16">物流跟踪</div>
          </div>
          <div
            class="pad30-l relative flex-auto mar2-l"
            v-if="delivery.expressVO && delivery.expressVO.data && delivery.expressVO.data.length > 0 && !dataMasking"
          >
            <div class="line" style="width: 1px; bottom: 3px; left: 213px"></div>
            <div class="flex mar10-b" v-for="(item, index) in delivery.expressVO.data" :key="index">
              <div class="f12 mar10-r" style="min-width: 110px">{{ item.timeM }}</div>
              <div class="certificate">
                <div class="flex items-center mar5-r">
                  <div class="f12 mar10-r">{{ item.timeH }}</div>
                  <div class="radius20 z-index2 flex-shrink self-start ball"></div>
                  <div class="mar10-l fb f12">{{ item.context }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="text-center relative mar-t-20">
              <img src="../../order/detail/images/cart-trans.png" />
            </div>
            <div class="text-center mar10-t">暂无物流相关信息，如有疑问，请联系平台客服</div>
          </div>
        </div>
      </div>
      <div class="flex flex-item1 mar20-b border" v-if="delivery.deliveryType == 'EXPRESS'">
        <div class="min-w373">
          <div class="flex pad25">
            <div class="wh100 radius4 overflow">
              <img :src="goodsPic + '?imageView2/1/w/100/h/100'" />
            </div>
            <div class="mar15-l lh28">
              <div class="flex">
                <div class="gray6 no-warp">发货方式</div>
                <div class="mar10-l">快递发货</div>
              </div>
              <div class="flex">
                <div class="gray6 no-warp">快递名称</div>
                <div class="mar10-l" v-if="dataMasking">{{ delivery.logisticsCompanyName.replace(/^(.{1}).+(.)/, "$1**$2") }}</div>
                <div class="mar10-l" v-else>{{ delivery.logisticsCompanyName }}</div>
              </div>
              <div class="flex">
                <div class="gray6 no-warp">快递单号</div>
                <div class="mar10-l" v-if="dataMasking">{{ delivery.logisticsNum.replace(/^(.{1}).+(.)/, "$1**$2") }}</div>
                <div class="mar10-l" v-else>{{ delivery.logisticsNum }}</div>
              </div>
              <div class="flex">
                <div class="no-warp gray6" style="width: 58px">发货时间</div>
                <div class="mar10-l">{{ delivery.sendTime }}</div>
              </div>
              <div class="flex" v-if="delivery && delivery.goodsQuantity > 1">
                <div class="no-warp gray6" style="width: 58px">发货数量</div>
                <div class="mar10-l">{{ delivery.goodsQuantity }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="border-l flex-auto pad30">
          <div class="flex mar20-b items-center">
            <img src="../../order/detail/images/cart.png" />
            <div class="mar10-l fb f16">物流跟踪</div>
          </div>
          <div
            class="pad30-l relative flex-auto mar2-l"
            v-if="delivery.expressVO && delivery.expressVO.data && delivery.expressVO.data.length > 0 && !dataMasking"
          >
            <div class="line" style="width: 1px; bottom: 3px; left: 213px"></div>
            <div class="flex mar10-b" v-for="(item, index) in delivery.expressVO.data" :key="index">
              <div class="f12 mar10-r" style="min-width: 110px">{{ item.timeM }}</div>
              <div class="certificate">
                <div class="flex items-center mar5-r">
                  <div class="f12 mar10-r">{{ item.timeH }}</div>
                  <div class="radius20 z-index2 flex-shrink self-start ball"></div>
                  <div class="mar10-l fb f12">{{ item.context }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="text-center relative mar-t-20">
              <img src="../../order/detail/images/cart-trans.png" />
            </div>
            <div class="text-center mar10-t">暂无物流相关信息，如有疑问，请联系平台客服</div>
          </div>
        </div>
      </div>
      <div class="flex flex-item1 mar20-b border" v-if="delivery.deliveryType == 'DELIVERYGOODSHL'">
        <div class="flex flex-column min-w373">
          <div class="flex pad25">
            <div class="wh100 radius4 overflow">
              <img :src="goodsPic + '?imageView2/1/w/100/h/100'" />
            </div>
            <div class="mar15-l lh28">
              <div class="flex">
                <div class="gray6 no-warp">发货方式</div>
                <div class="mar10-l">货联发货</div>
              </div>
              <div class="flex">
                <div class="gray6 no-warp">车主姓名</div>
                <div class="mar10-l" v-if="dataMasking">{{ delivery.driverName.substring(0, 1) + new Array(delivery.driverName.length).join("*") }}</div>
                <div class="mar10-l" v-else>{{ delivery.driverName }}</div>
              </div>
              <div class="flex">
                <div class="gray6 no-warp">车主电话</div>
                <div class="mar10-l" v-if="dataMasking">{{ delivery.cellPhoneNum.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2") }}</div>
                <div class="mar10-l" v-else>{{ delivery.cellPhoneNum }}</div>
              </div>
              <div class="flex">
                <div class="no-warp gray6" style="width: 58px">发货时间</div>
                <div class="mar10-l">{{ delivery.sendTime }}</div>
              </div>
              <div class="flex" v-if="delivery && delivery.goodsQuantity > 1">
                <div class="no-warp gray6" style="width: 58px">发货数量</div>
                <div class="mar10-l">{{ delivery.goodsQuantity }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="border-l flex-auto pad30">
          <div class="flex mar20-b items-center">
            <img src="../../order/detail/images/cart.png" />
            <div class="mar10-l fb f16">物流跟踪</div>
          </div>
          <div class="pad30-l flex-auto mar2-l">
            <div class="mar5-b">· 物流 当前状态请联系司机 {{ delivery.driverName }} {{ delivery.cellPhoneNum }}</div>
            <div class="pad25"></div>
            <div class="flex justify-center btn-group text-center">
              <div class="item pointer" style="max-width: 302px">查看轨迹</div>
            </div>
          </div>
        </div>
        <div class="border-l flex-shrink pad30-t pad20-lr w290">
          <div class="f16 fb mar10-b">运输凭证</div>
          <div class="relative certificate" v-if="delivery.expressVO && delivery.expressVO.fileList && delivery.expressVO.fileList.length > 0 && !dataMasking">
            <div class="line" style="bottom: 84px"></div>
            <div class="flex mar10-t mar20-b mar19-l flex-wrap">
              <div class="wh64 radius4 mar5-r overflow" v-for="(fileUrl, index) in delivery.expressVO.fileList" :key="index">
                <video class="video-player" v-if="fileUrl.imgType && fileUrl.imgType == 1" :src="fileUrl.imgUrl + '?imageView2/1/w/80/h/80'" />
                <el-image
                  :src="fileUrl.imgUrl + '?imageView2/1/w/80/h/80'"
                  :preview-src-list="
                    delivery.expressVO.fileList.map((item) => {
                      return item.imgUrl;
                    })
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../order/detail/detail.scss";
</style>

<script>
export default {
  name: "logistics_dtl",
  props: {
    orderDelivery: {},
    goodsPic: {},
    dataMasking: { type: String },
  },
};
</script>
